// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__8YLjJ","content":"RecentSearches_content__3Tv35"};